import { render, staticRenderFns } from "./medical-history.vue?vue&type=template&id=0512d103&scoped=true&"
import script from "./medical-history.vue?vue&type=script&lang=js&"
export * from "./medical-history.vue?vue&type=script&lang=js&"
import style0 from "./medical-history.vue?vue&type=style&index=0&id=0512d103&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0512d103",
  null
  
)

export default component.exports